import { Catalog } from '@df/catalog/catalog.interfaces';

export namespace NPageSearch {
    export const OUTLET_BLOCK_ID = 'page-search';

    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export const SEARCH_MEGANAV_KEY = 'page-header-search-meganav';
    export const SEARCH_OFF_CANVAS_KEY = 'page-off-canvas-search';
    export const SEARCH_OUTLET_COMPONENT_ID = 'page-header-search-outlet';

    // search start
    export interface IBlockDataContent {
        // top links on the side (popular searches)  title
        popularSearchesTitle: string;

        featureLinksSections: IFeatureLinksSection[];

        // no result messaging
        noResultTitle: string;
        noResultSubtitle: string;

        // main part cards
        contentCardsTitle?: string;
        contentCards: IContentCard[];
    }

    interface IFeatureLinksSection {
        title: string;
        links: IFeatureLink[];
    }
    interface IFeatureLink {
        image?: string;
        label: string;
        link: string;
    }
    interface IContentCard {
        image: string;
        title: string;
        buttonLabel: string;
        link: string;
    }
}
